/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Adjust_CurrentInputs */

const vi_customer_debt_adjust_current = /** @type {(inputs: Customer_Debt_Adjust_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dư hiện tại`)
};

/**

* @param {Customer_Debt_Adjust_CurrentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_adjust_current = /** @type {((inputs?: Customer_Debt_Adjust_CurrentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Adjust_CurrentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_adjust_current(inputs)
});